export const regimeLabels = {
  ALTSEASON: 'Altseason',
  DEFENSIF: 'Défensif',
  DEFENSIVE: 'Défensif',
  ROTATION_ETH: 'Rotation ETH',
  NEUTRE: 'Neutre',
  NEUTRAL: 'Neutre',
  BTC_DOMINANCE_UP: 'BTC Dominance ↑',
  BITCOIN_DOMINANT: 'BTC Dominance ↑',
  ETH_ROTATION: 'Rotation ETH',
};

export const riskLabels = {
  RISK_ON: 'Offensif',
  RISK_OFF: 'Défensif',
  NEUTRAL: 'Neutre',
  RISK_NEUTRAL: 'Neutre',
};

export const getMarketRegimeLabel = (regime) => {
  const rawRegime = String(regime || '').trim();
  if (!rawRegime) {
    return 'N/A';
  }

  return regimeLabels[rawRegime.toUpperCase()] || rawRegime;
};

export const getMarketRiskLabel = (risk) => {
  const rawRisk = String(risk || '').trim();
  if (!rawRisk) {
    return 'N/A';
  }

  return riskLabels[rawRisk.toUpperCase()] || rawRisk;
};